import { createFileRoute } from "@tanstack/react-router";

import ProcessingList from "@/pages/processing/ProcessingList";

export const Route = createFileRoute("/processing/")({
  component: ProcessingList,
});
